module.exports = __webpack_public_path__ + "img/11_003.aa054fb4.webp";